import { BadgeVerifiedCredentials } from '@seek/certsy-ui';
import { useTranslations } from '@vocab/react';
import { Box, TooltipRenderer, Text } from 'braid-design-system';

import translations from './.vocab';

export const VerifiedCredentialsBadge = ({
  idSuffix,
}: {
  idSuffix: string;
}) => {
  const { t } = useTranslations(translations);
  return (
    <TooltipRenderer
      id={`seek-pass-verified-credentials-tooltip-${idSuffix}`}
      tooltip={
        <Text>
          {t('Some credentials in this profile are verified by SEEK Pass.')}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps}>
          <BadgeVerifiedCredentials>
            {t('Verified credentials')}
          </BadgeVerifiedCredentials>
        </Box>
      )}
    </TooltipRenderer>
  );
};
